import React, { Component } from 'react';
import './Whim.css'
import services from '../services'

declare var google;

class Whim extends Component {
    constructor(props) {
      super(props)

      this.state = {
        selectedAddress: [],
        whim: {},
        whims: [],
        shippingPrice: 'Cargando..',
        loading: false
      }

      this.initAutoComplete = this.initAutoComplete.bind(this)
      this.changeWhimName = this.changeWhimName.bind(this)
      this.createOrder = this.createOrder.bind(this)
      this.getShippingCharges = this.getShippingCharges.bind(this)
    }

    componentDidMount() {
        let selectedAddress = JSON.parse(localStorage.getItem('address'))
        this.setState({ selectedAddress} ,
          ()=> {
            this.initAutoComplete()
            this.getShippingCharges()
           })
    }

    async getShippingCharges() {
       let res = await services.getShippingCharges(this.state.selectedAddress.lat,this.state.selectedAddress.lng )
        res = res.data;
        let whimStore = res['whim']
        let shippingPrice = whimStore[0].value;
        this.setState({
          shippingPrice
        })

    }

    initAutoComplete() {
      let autocomplete = new google.maps.places.Autocomplete(this.refs.where, {
        types: ["establishment"],
      });
      let circle = new google.maps.Circle({
        center: {lat: this.state.selectedAddress.lat , lng: this.state.selectedAddress.lng},
        radius: 5,
      });
      autocomplete.setBounds(circle.getBounds());
      autocomplete.addListener("place_changed", () => {
         let place = autocomplete.getPlace();
         let lng = place.geometry.location.lng()
         let lat = place.geometry.location.lat()
         let whim = this.state.whim;
         whim.where = place.name;
         whim.place_info = {
            lat: lat,
            lng: lng,
            name: place.name,
            place_id: place.place_id
         }
         let whims = this.state.whims;
         whims.push(whim)
        this.setState({
          whim,
          whims
        })
      })
    }

    changeWhimName(e) {
      let whim = this.state.whim;
      whim.whim = e.target.value
      this.setState({
        whim
      })
    }

    async createOrder(event) {
      this.setState({
        loading: true
      })
      event.preventDefault();
      let resToken = await services.getUserToken()
      if(resToken.success) {
        resToken = resToken.data;
        let token = resToken.token
        let order = {
          address:  JSON.parse(localStorage.getItem('newAddress')),
          comment: '',
          coupon: [],
          delivery: 0,
          delivery_date: '',
          device_type: 2,
          payment: {
            name: 'cash'
          },
          platform: 2,
          products: [],
          store_id: 0,
          tip: 0,
          total_value: 0,
          whims: this.state.whims,
          token: token,
          source: '',
          source_value: '',
          source_type : ''
        }
        let resOrder = await services.createOrder(order)
        resOrder = resOrder.data
        if(resOrder.application_user_id) {
          this.setState({
            loading: false
          })
           alert("Orden Realizada!")
        }
      }

    }


  render() {
    return (
      <div>
        <form className="row container center" onSubmit={this.createOrder}>
            <div className="input-field col s12">
             <textarea id="icon_prefix2" value={this.state.whim.name} onChange={this.changeWhimName} className="materialize-textarea" required></textarea>
             <label htmlFor="icon_prefix2">¿Qué quieres?</label>
           </div>
           <div className="input-field col s12">
             <input  ref="where" placeholder="" id="where" type="text" required/>
             <label htmlFor="where">¿Dónde lo conseguimos?</label>
           </div>
           <p className="center cost"> La tarifa base de pedir por ¨Antojo¨ es de $10 pesos + el 9% del costo del antojo. Si vemos que el tiempo de tu antojo excede 25 minutos, te contactaremos para darte el costo.</p>
          { !this.state.loading && <div className="col s12 ">
             <button className="btn waves-effect waves-light" type="submit" name="action">Ordenar</button>
           </div>
          }
          { this.state.loading  &&
            <div className="preloader-wrapper small active">
               <div className="spinner-layer spinner-teal-only">
                 <div className="circle-clipper left">
                   <div className="circle"></div>
                 </div><div className="gap-patch">
                   <div className="circle"></div>
                 </div><div className="circle-clipper right">
                   <div className="circle"></div>
                 </div>
               </div>
             </div>
          }
         </form>
      </div>
    );
  }
}

export default Whim;



// WEBPACK FOOTER //
// ./src/whim/Whim.js